import { render } from "./OneTimePassword.vue?vue&type=template&id=76249528&scoped=true"
import script from "./OneTimePassword.vue?vue&type=script&lang=js"
export * from "./OneTimePassword.vue?vue&type=script&lang=js"

import "./OneTimePassword.vue?vue&type=style&index=0&id=76249528&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76249528"]])

export default __exports__